// @flow

import React from 'react';
import type { CoqueRetailer, RoiResult } from '../../../types/apolloType';
import RoiInterface from './RoiInterface';
import type { UrlParam } from '../../../utils/urlUtils';

type Props = {
  currentRetailer: ?CoqueRetailer,
  mainStoreCodstr: number,
  addedCustomRetailer: CoqueRetailer,
  locationParams: UrlParam,
}

type State = {
  isLoading: boolean,
  roiResult: ?RoiResult,
  roiSuggestionResult: ?RoiResult,
}

class RoiComponent extends React.Component<Props, State> {
  state = {
    roiResult: this.props.currentRetailer.roiResult,
  }

  shouldComponentUpdate(nextProps: Props, nextState: State, nextContext: any): boolean {
    if (this.props.currentRetailer.codeRetailerProposition
      !== nextProps.currentRetailer.codeRetailerProposition) {
      nextState.roiResult = nextProps.currentRetailer.roiResult;
    }
    return true;
  }

  render() {
    const { currentRetailer } = this.props;
    return (
      <div className="roi-data">
        <RoiInterface
          key={`${currentRetailer.codeRetailerProposition}-interface`}
          codeRetailerProposition={currentRetailer.codeRetailerProposition}
          roiResult={this.state.roiResult}
          roiInput={this.props.currentRetailer.roiInput}
          codstr={this.props.mainStoreCodstr}
          addedCustomRetailer={this.props.addedCustomRetailer}
          locationParams={this.props.locationParams}
        />
      </div>
    );
  }
}

export default RoiComponent;
